module.exports = __webpack_public_path__ + "img/lorry.f8fa6a1d.png";